var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      visible: _vm.previewVisible,
      title: _vm.$t("配件明细"),
      width: 1000
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      },
      ok: _vm.handleSure
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      },
      model: _vm.dataFrom,
      rules: _vm.dataRule
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("零配件编码"),
      prop: "code"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("零配件编码")
    },
    model: {
      value: _vm.dataFrom.code,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "code", $$v);
      },
      expression: "dataFrom.code"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("配件名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("配件名称")
    },
    model: {
      value: _vm.dataFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "name", $$v);
      },
      expression: "dataFrom.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("配件照片"),
      prop: "photo"
    }
  }, [_c("a-upload", {
    attrs: {
      action: _vm.action,
      "list-type": "picture-card",
      "file-list": _vm.fileList,
      accept: "image/*",
      data: {
        module: "auditAttachment"
      },
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      },
      showUploadList: {
        showPreviewIcon: false,
        showRemoveIcon: true
      }
    },
    on: {
      change: _vm.handleChange
    }
  }, [_vm.fileList.length < 8 ? _c("div", [_c("a-icon", {
    attrs: {
      type: "plus"
    }
  }), _c("div", {
    staticClass: "ant-upload-text"
  }, [_vm._v(" " + _vm._s(_vm.$t("上传照片")) + " ")])], 1) : _vm._e()])], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("门店意见"),
      prop: "opinion"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("门店意见")
    },
    model: {
      value: _vm.dataFrom.opinion,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "opinion", $$v);
      },
      expression: "dataFrom.opinion"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("价格") + _vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId)),
      prop: "price"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("价格")
    },
    model: {
      value: _vm.dataFrom.price,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "price", $$v);
      },
      expression: "dataFrom.price"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("备注"),
      prop: "remarks"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("备注")
    },
    model: {
      value: _vm.dataFrom.remarks,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "remarks", $$v);
      },
      expression: "dataFrom.remarks"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };